import MarketingUpdate from './MarketingUpdate';

export default MarketingUpdate;
